import React from 'react'
import { useSelector } from 'react-redux'
import { Box, Card, CardContent, CardHeader, TableContainer, Table, TableBody } from '@mui/material'
import Definition from '../Definition'

const Owner = () => {
  const ownerData = useSelector(state => state.business.userInfo)
  return (
    <Box my={2}>
      <Card>
        <CardHeader subheader="Primary contact" />
        <CardContent>
          <TableContainer>
            <Table>
              <TableBody>
                <Definition id="First name" value={ownerData.firstName} />
                <Definition id="Last name" value={ownerData.lastName} />
                <Definition id="Title" value={ownerData.job} />
                <Definition id="Email" value={ownerData.email} />
                <Definition id="Phone" value={ownerData.phone} />
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  )
}

export default Owner
